module.exports = __webpack_public_path__ + "files/2763f5ae6f9fae35141664340a3ff4e4.png";